function MultipleChoiceIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <rect
          x='3.5'
          y='4'
          width='25'
          height='25'
          rx='3'
          stroke='currentColor'
          strokeWidth='2'
          fill='none'
        />
        <path
          d='M9.5 17.5459L13.6592 21.7051L23.2052 12.1592'
          stroke='currentColor'
          strokeWidth='2'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
}

export default MultipleChoiceIcon;
